import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import IncomeStatementWidget from "../../../finance/widgets/income-statement";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class TeamReportsSection6Step3 extends PureComponent {
  get left_content() {
    const { interestExpense } = this.props;

    return (
      <span>
        <u>Financial Impact of Your Decisions</u>
        <br />
        <br />
        Finance impacts the following line items:
        <br />
        <br />- <b>Interest Expense:</b> Your Interest Expense of{" "}
        <AbbreviatedMillionNumberFormat
          value={interestExpense}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        was driven by 2 things:
        <br />
        <br />
        1. The amount of money you borrowed from lenders
        <br />
        2. The weighted average interest rate your lenders charged you
        <br />
        <br />
        <div className="formula">
          Interest Expense = Money Borrowed x Interest Rates
        </div>
        <br />
        <br />
        Lenders determine your interest rates based on your debt to capital
        ratio. To learn more about Debt to capital ratio, please review the
        following content:
        <br />
        <TypeformLink
          title="Debt to Capital"
          url={TypeformUrls.DEBT_TO_CAPITAL}
        />
      </span>
    );
  }

  get right_content() {
    const { incomeStatement, current_year } = this.props;

    return (
      <IncomeStatementWidget
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Financing Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection6Step3;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-6/step-3.js